import React from 'react';
import { FaCompass } from 'react-icons/fa';

const CompassIcon = () => {
  return (
    <div className="compass-icon">
      <FaCompass />
    </div>
  );
};

export default CompassIcon; 